export default __webpack_public_path__ + "static/media/1.bf4eb61f.jpeg";